import { useState, useEffect } from 'react'

import { getProfileAndRegions } from 'lmcv/services/shared'

export function useProfileAndRegions () {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    getProfileAndRegions()
      .then(data => {
        setData(data)
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }, [])

  return [data, loading, error]
}
